// Composition root, like Program.cs.
// domain/ holds records and rules. state/ holds the in-memory services.
// App.tsx is the route table. pages/ are the screens.
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { AuthProvider } from "./state/AuthProvider";
import { installFetchLoader } from "./state/loaderActivity";
import { EventsProvider } from "./state/events";
import { FormsProvider } from "./state/forms";
import { LocaleProvider } from "./state/i18n";
import { MailProvider } from "./state/MailProvider";
import { StudentsProvider } from "./state/students";
import "./styles.css";

installFetchLoader();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <LocaleProvider>
      <StudentsProvider>
        <FormsProvider>
          <EventsProvider>
            <MailProvider>
              <AuthProvider>
                <App />
              </AuthProvider>
            </MailProvider>
          </EventsProvider>
        </FormsProvider>
      </StudentsProvider>
    </LocaleProvider>
  </StrictMode>,
);
